import React from 'react';
import { Loader2 } from 'lucide-react';

export const PanelAnalisis = ({ titulo, icono: Icono, testid, loading, error, vacio, children, extra }) => (
  <section className="rounded-xl border border-slate-200 bg-white p-5" data-testid={testid}>
    <header className="mb-4 flex items-center justify-between gap-2">
      <h3 className="flex items-center gap-2 text-sm font-semibold text-slate-800">
        {Icono && <Icono size={16} className="text-slate-500" />}
        {titulo}
      </h3>
      {extra}
    </header>
    {loading ? (
      <div className="flex justify-center py-10"><Loader2 className="animate-spin text-slate-400" size={22} /></div>
    ) : error ? (
      <p className="py-6 text-center text-sm text-red-500" data-testid={`${testid}-error`}>{error}</p>
    ) : vacio ? (
      <p className="py-6 text-center text-sm text-slate-400" data-testid={`${testid}-vacio`}>{vacio}</p>
    ) : children}
  </section>
);
